export default "__VITE_ASSET__7e4958c7__"